module.exports = __webpack_public_path__ + "img/YongjiZhang.99ab66ef.jpg";